import { Posts } from '../../services/Posts';

export const ADD_POST = 'ADD_POST';
export const REMOVE_POST = 'REMOVE_POST';
export const UPDATE_POST = 'UPDATE_POST';

export const SET_POSTS_FOR_BLOG = 'SET_POSTS_FOR_BLOG';

const PAGINATION_DEFAULT_PAGE = 1;
const PAGINATION_DEFAULT_LIMIT = 15;

export function addPost(post) {
  return {
    type: ADD_POST,
    post: post
  };
}

export function removePost(id) {
  return {
    type: REMOVE_POST,
    id: id
  };
}

export function updatePost(post) {
  return {
    type: UPDATE_POST,
    post: post
  };
}

function setPostsForBlog(posts, metadata) {
  return {
    type: SET_POSTS_FOR_BLOG,
    posts,
    metadata
  };
}

export const fetchPosts = (blogId) => {
  return async (dispatch) => {
    try {
      const { data, metadata } = await Posts.getAllPaginated(blogId, PAGINATION_DEFAULT_PAGE, PAGINATION_DEFAULT_LIMIT);
      dispatch(setPostsForBlog(data, metadata));
    } catch (error) {
      console.log(error);     
    }
  }
}

export const fetchPublishedPaginated = (blogId, page, limit, sortBy, order) => {
  return async (dispatch) => {
    try {
      const {data, metadata} = await Posts.getAllPaginated(blogId, page, limit, sortBy, order);
      dispatch(setPostsForBlog(data, metadata));
    } catch (error) {
      console.log(error);     
    }
  }
} 